import types from '../types'

// keep track of which details links have already used
const initialState = {}

const resolvedDetailsLinksReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.DETAILS_UPDATE:
      return handleDetailsUpdate(
        state,
        action.response,
        action.detailsLink,
        action.oItinId,
        action.iItinId,
      )
    case types.DETAILS_UPDATE_FAILED:
      return handleDetailsUpdate(
        state,
        null,
        action.detailsLink,
      )
    default:
      return state
  }
}

const handleDetailsUpdate = (state, response, detailsLink, oItinId, iItinId) => {
  if (response == null) {
    // If no response was provided (eg details update failed) then do nothing
    return state
  }

  const detailsLinkCache = {
    oItinId,
    iItinId,
    response,
  }

  return {
    ...state,
    [detailsLink.data]: detailsLinkCache,
  }
}

export default resolvedDetailsLinksReducer
